import type {TFunction} from 'i18next';
import {LOCK_OPENING_TYPES, LOCK_VENDORS, Unlock} from '@chekin/core';

export const getCodeDependsOnLockType = (unlock: Unlock) => {
  if (unlock.lock.vendor === LOCK_VENDORS.keynest) {
    return unlock.collection_code;
  }

  return unlock.lock.opening_type !== LOCK_OPENING_TYPES.LINK ? unlock.pass_code : '';
};

const OPENING_TYPE_LABEL_KEYS: Record<LOCK_OPENING_TYPES, string> = {
  [LOCK_OPENING_TYPES.CODE]: 'lock_opening_type.keypad',
  [LOCK_OPENING_TYPES.LINK]: 'lock_opening_type.smart_lock',
  [LOCK_OPENING_TYPES.CODE_AND_LINK]: 'lock_opening_type.keypad_and_smart_lock',
};

export function getDoorSubtitle(unlock: Unlock, t: TFunction) {
  const openingType = unlock?.lock?.opening_type;
  const openingLabelKey = openingType ? OPENING_TYPE_LABEL_KEYS[openingType] : undefined;

  return [unlock?.lock?.room_number, openingLabelKey && t(openingLabelKey)]
    .filter(Boolean)
    .join(' · ');
}
